import getJsFormsUrl from 'forms-utils-lib/urls/public/getJsFormsUrl';
import { na1 } from 'hubspot-url-utils/hublets';
export const getV4EmbedCode = ({
  formId,
  portalId,
  sfdcCampaignId,
  env,
  region = na1
}) => `<script src="${getJsFormsUrl()}/forms/embed/${portalId}.js" defer></script>
<div class="hs-form-frame"${env === 'qa' ? ` data-env="qa"` : ''} data-region="${region}" data-form-id="${formId}" data-portal-id="${portalId}"${sfdcCampaignId ? ` data-sfdc-campaign-id="${sfdcCampaignId}"` : ``}></div>`;
export default getV4EmbedCode;